import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107135Status: 'idle',
    startProcess107135Error: undefined as any,
    loadUserParamsProcess107135Status: 'idle',
    loadUserParamsProcess107135Error: undefined as any,

    process107135List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107135 = createAsyncThunk('process107135Slice/startProcess107135', async ({ process107135 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107135/`,
        prepareData(process107135),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107135Status } = getState().process107135Slice
        return startProcess107135Status !== 'pending'
    }
})

export const loadUserParamsProcess107135 = createAsyncThunk('process107135Slice/loadUserParamsProcess107135', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107135/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107135Status } = getState().process107135Slice
        return loadUserParamsProcess107135Status !== 'pending'
    }
})

const Process107135Slice = createSlice({
    name: 'process107135Slice',
    initialState,
    reducers: {
        resetstartProcess107135: (state) => {
            state.job = undefined
            state.startProcess107135Error = undefined
        },
        resetstartProcess107135Error: (state) => {
            state.startProcess107135Error = undefined
        },
        resetloadUserParamsProcess107135: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107135Error = undefined
        },
        resetloadUserParamsProcess107135Error: (state) => {
            state.loadUserParamsProcess107135Error = undefined
        },
        removeFromProcess107135ListById: (state, action) => {
            state.process107135List = state.process107135List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107135ListByIds: (state, action) => {
            state.process107135List = state.process107135List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107135List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107135Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107135List = []
            state.startProcess107135Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107135.pending, (state) => {
            state.startProcess107135Status = 'pending'
            state.startProcess107135Error = undefined
        })
        builder.addCase(startProcess107135.fulfilled, (state, action) => {
            state.startProcess107135Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107135.rejected, (state, action) => {
            state.startProcess107135Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107135Error = action.error.message
            } else {
                state.startProcess107135Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107135.pending, (state) => {
            state.loadUserParamsProcess107135Status = 'pending'
            state.loadUserParamsProcess107135Error = undefined
        })
        builder.addCase(loadUserParamsProcess107135.fulfilled, (state, action) => {
            state.loadUserParamsProcess107135Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107135.rejected, (state, action) => {
            state.loadUserParamsProcess107135Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107135Error = action.error.message
            } else {
                state.loadUserParamsProcess107135Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107135,
    resetstartProcess107135Error,
    resetloadUserParamsProcess107135,
    resetloadUserParamsProcess107135Error,
    removeFromProcess107135ListById,
    removeFromProcess107135ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107135Slice.actions
export default Process107135Slice.reducer
